<template>
  <div class="def-input-search">
    <DefTrackingClick @close="handlerClose">
      <label
        class="input-search-header"
        :class="{
          'input-search-header_invalid': !isValid || isError,
        }"
        @click="isActive = true"
      >
        <input
          ref="hiddenInput"
          type="hidden"
          class="input-search-header__hidden"
          :name="name"
          :value="value"
          :required="required"
          @invalid.prevent="handlerInvalid"
        />
        <span
          class="input-search-header__placeholder"
          :class="{ 'input-search-header__placeholder_center': !header && !isActive }"
        >
          {{ placeholder }}
        </span>

        <input class="input-search-input" :value="header" type="text" />

        <svg :class="{ 'input-search-close_active': isActive }" class="input-search-close">
          <use xlink:href="#svg-select"></use>
        </svg>
      </label>
    </DefTrackingClick>
    <SlideUpDown
      v-if="!readonly && $slots.default"
      :model-value="isActive"
      class="input-search-drop"
    >
      <DefScrollbar ref="city" class="input-search-drop__scroll">
        <div class="input-search-drop__items" @click="handlerSelect">
          <slot />
        </div>
      </DefScrollbar>
    </SlideUpDown>
  </div>
</template>

<script>
import SlideUpDown from 'vue3-slide-up-down';
import DefTrackingClick from '@components/Def/DefTrackingClick/DefTrackingClick.vue';
import DefScrollbar from '@components/Def/DefScrollbar/DefScrollbar.vue';

export default {
  name: 'DefInputSearch',
  components: { DefScrollbar, DefTrackingClick, SlideUpDown },
  props: {
    name: String,
    placeholder: String,
    required: Boolean,
    autocomplete: Boolean,
    value: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    id: String,
    form: String,
    type: {
      type: String,
      default: 'text',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isError: {
      type: Boolean,
      default: false,
    },
    pattern: {
      type: [String, null],
      default: null,
    },
    header: {
      type: [String, undefined],
    },
  },
  data() {
    return {
      isValid: true,
      isActive: false,
    };
  },
  methods: {
    handlerInvalid() {
      if (this.required) {
        this.isValid = false;
      }
    },
    handlerSelect({ target }) {
      this.isInvalid = false;
      const { hiddenInput } = this.$refs;
      // this.isActive = false;

      if ('createEvent' in document && hiddenInput) {
        const evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', true, true);
        hiddenInput.dispatchEvent(evt);
      } else hiddenInput?.fireEvent('onchange');
    },
    handlerClose() {
      this.isActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.def-input-search {
  position: relative;
}
.input-search-header {
  display: flex;
  align-items: flex-end;
  position: relative;
  height: 52px;
  padding: 8px 46px 8px 16px;
  border: 1px solid #c8c8c8;
  margin-bottom: 16px;
  &__placeholder {
    position: absolute;
    top: 8px;
    color: var(--color-dark-grey);
    transition: 0.2s linear top;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
    font-size: 14px;
    font-weight: 500;
    &_center {
      font-size: rem(16);
      top: 16px;
    }
  }
  &_invalid {
    border-color: var(--background-red);
  }
}
.input-search-drop {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% - 1px);
  background-color: #fff;
  z-index: 2;
  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  &__scroll {
    max-height: 250px;
    overflow-y: auto;
    border: 1px solid #cacece;
  }
  &__items {
    :deep(> *) {
      display: flex;
      align-items: center;
      padding: 8px 16px;
      cursor: pointer;
      transition: 0.2s linear background-color;
      &:hover {
        background-color: #fafafa;
      }
    }
  }
}
.input-search-close {
  position: absolute;
  transition: 0.2s linear transform;
  right: 20px;
  width: 20px;
  height: 20px;
  fill: var(--color-main);
  top: 50%;
  transform: translateY(-50%);
  &_active {
    transform: rotate(180deg) translateY(50%);
  }
}
.input-search-input {
  padding: 0;
  font-weight: 500;
  font-size: rem(16);
  border: none;
  height: 20px;
  transition: 0.2s linear border-bottom-color;
  width: 100%;
}
</style>
